import { createSlice } from "@reduxjs/toolkit";
import {
  fetchProviderLocations,
  fetchUpdateProviderLocationStatus,
} from "./ProviderLocationActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const providerLocationList = createSlice({
  name: "providerLocationList",
  initialState: {
    isLocationDataLoading: false,
    locationData: [],
    locationError: null,
    locationErrorMsg: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProviderLocations.pending, (state) => {
        state.isLocationDataLoading = true;
        state.locationError = null;
      })
      .addCase(fetchProviderLocations.fulfilled, (state, action) => {
        state.isLocationDataLoading = false;
        state.isLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data?.metadata?.outcome?.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.locationData = [];
            state.locationError = false;
          } else {
            state.locationError = true;
            state.locationErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.locationError = false;
          state.locationData =
            action.payload?.data?.data?.providerLocationItemResponseDTOs;
        }
      })
      .addCase(fetchProviderLocations.rejected, (state, action) => {
        state.isLocationDataLoading = false;
        state.locationError = action.error.message;
      });
    builder
      .addCase(fetchUpdateProviderLocationStatus.pending, (state) => {
        state.isLocationDataLoading = true;
        state.locationError = null;
      })
      .addCase(fetchUpdateProviderLocationStatus.fulfilled, (state, action) => {
        state.isLocationDataLoading = false;
        state.isLoading = false;
        if (!action.payload.success) {
          state.locationError = true;
          state.locationErrorMsg = getApiErrorMessage(action.payload.status);
        }
      })
      .addCase(fetchUpdateProviderLocationStatus.rejected, (state, action) => {
        state.isLocationDataLoading = false;
        state.locationError = action.error.message;
      });
  },
});

export const providerLocationListReducer = providerLocationList.reducer;
